import classes from './Footer.module.css';
import Instagram from '../../assets/icons/Instagram.svg'
import React from "react";
import Button from "../button/Button";

const Footer = () => {
    return (
        <div className={classes.Container}>
            <div className={classes.ContainerInner}>
                <div className={classes.Section}>
                    <div className={classes.Header}>
                        Contact me
                    </div>
                    <div className={classes.Content}>
                        <a href = "mailto: pristinelashllc@gmail.com">pristinelashllc@gmail.com</a>
                    </div>
                </div>
                <div className={classes.Section}>
                    <div className={classes.Header}>
                        Address
                    </div>
                    <div className={classes.Content}>
                        <a href="https://www.google.com/maps/place/7305+Linden+Ave+N,+Seattle,+WA+98103/@47.6819457,-122.3466064" target={'_blank'}>
                            7305 Linden Ave N,
                            Seattle, WA 98103
                        </a>
                    </div>
                </div>
                <div className={classes.Section}>
                    <div className={classes.Content}>
                        <Button className={classes.HoursButton} onClick={() => window.open("https://pristine-lash.square.site")}>Hours</Button>
                    </div>
                </div>
                <div className={[classes.FullSection, classes.TextSmall].join(' ')}>
                    Pristine lash studio located near Greenlake, Fremont, Wallingford, and Ballard in Seattle, WA.
                </div>
                <div className={classes.FullSection}>
                    <a href={'https://www.instagram.com/pristine.lash/'} className={classes.Instagram} target={'_blank'}>
                        <img src={Instagram} alt={'https://www.instagram.com/pristine.lash/'}/>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer;
